import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowExpandVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-expand-ver"} maskId="square-filled-radius-0-stroke-1-IconArrowExpandVer"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 1.79297L16.7072 6.50007L16.0001 7.20718L12.5 3.70717V20.293L16.0001 16.793L16.7072 17.5001L12.0001 22.2072L7.29297 17.5001L8.00008 16.793L11.5 20.293V3.7072L8.00008 7.20718L7.29297 6.50008L12.0001 1.79297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowExpandVer;
